<template lang="pug">
v-carousel(
  v-model="inputValue"
  height="100%"
  cycle
  hide-delimiters
  hide-delimiter-background
  :show-arrows="false"
  :interval="5000"
)
  v-carousel-item(
    v-for="(item, idx) in items"
    :key="idx"
  )
    slot(name="default" v-bind="{ item, idx }")
</template>

<script>
export default {

  props: {
    value: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
